export default __webpack_public_path__ + "web/src/assets/images/diff/no-changes-script-pic@2x.png?[fullhash]";